import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        average: '=',
        count: '=',
        groupAverage: '=',
        isComparison: '=',
        title: '=',
        comparisonTitle: '=',
        showAverages: '=?',
        showTitle: '=?'
    },
    template: `
    <span class="resultwrapper" ng-if="vm.average">
        <span class="title" ng-if="vm.showTitle">
            <strong class="ng-binding">{{ vm.title }}</strong>
        </span>
        <span class="bar">
            <span class="result" ng-class="{ result02: vm.isComparison }" ng-style="{ width: vm.width }">
                <span>{{ vm.average | number: 1 }}</span>
            </span>
            <span class="norm" ng-if="vm.groupAverage && vm.showAverages">
                <span
                    ng-style="{ left: vm.groupWidth }"
                    uib-tooltip="{{vm.groupAverage | number: 1}}"
                    tooltip-placement="top-left"
                ></span>
             </span>
        </span>
    </span>
    `
})
export default class {
    constructor (EvaluationReportService) {
        this.EvaluationReportService = EvaluationReportService;
    }

    $onInit () {
        if (typeof this.showAverages === 'undefined') {
            this.showAverages = true;
        }
        if (typeof this.showTitle === 'undefined') {
            this.showTitle = true;
        }
        this.width = this.EvaluationReportService.getWidth(this.average, this.count);
        this.groupWidth = this.EvaluationReportService.getWidth(this.groupAverage, this.count);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/public/report/partials/bar/index.js